import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const FileInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <label
        className={cn(
          'relative flex items-center cursor-pointer h-[33px] w-[33px] rounded-full bg-[#CCD8F5] text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
      >
        <input type='file' className='hidden' ref={ref} {...props} />
        <img
          className='w-5 h-5 text-gray-500 mx-auto'
          src='/assets/icons/upload.svg'
          alt='upload'
        />
      </label>
    );
  }
);

FileInput.displayName = 'FileInput';

export { FileInput };
